<form [formGroup]="form">
    <div class="row">
        <div class="form-group col-md-6">
            <label for="businessName">
                <h3>Company Name: <i class="pi pi-question-circle tooltip-icon"
                                     pTooltip="{{getBusinessNameTooltip()}}"></i>
                </h3>
            </label> <input [ngClass]="{ 'is-invalid': displayError(f.businessName)}"
                            class="form-control"
                            formControlName="businessName"
                            id="businessName"
                            placeholder="Registered name of your business"
                            type="text"/>
            @if (displayError(f.businessName)) {
                <div class="form-input-error">
                    @if (f.businessName.errors.required) {
                        <div>Business name is required.</div>
                    }
                    @if (f.businessName.errors.duplicateBusinessName) {
                        <div>This business name already exists.</div>
                    }
                    @if (f.businessName.errors.maxlength) {
                        <div>Business name cannot exceed 255 characters.</div>
                    }
                </div>
            }
        </div>

        <div class="form-group col-md-6">
            <validation [formGroup]="form" controlName="mobileNumber" displayName="Contact number">
                <label for="contact-number"><h3>Contact Number:</h3></label>
                <input [ngClass]="{ 'is-invalid': displayError(f.mobileNumber) }"
                       autocomplete="tel"
                       class="form-control"
                       formControlName="mobileNumber"
                       id="contact-number"
                       placeholder="0831234567 or +27831234567"
                       type="tel"/>
            </validation>
        </div>
    </div>

    <div class="row">
        <div class="form-group col-md-6">
            <label for="name"><h3>Name:</h3></label> <input [ngClass]="{ 'is-invalid': displayError(f.name)}"
                                                            autocomplete="given-name"
                                                            class="form-control"
                                                            formControlName="name"
                                                            id="name"
                                                            placeholder=""
                                                            type="text"/>
            @if (displayError(f.name)) {
                <div class="form-input-error">
                    @if (f.name.errors.required) {
                        <div>Name is required</div>
                    }
                </div>
            }
        </div>

        <div class="form-group col-md-6">
            <label for="surname"><h3>Surname:</h3></label> <input [ngClass]="{ 'is-invalid': displayError(f.surname) }"
                                                                  autocomplete="family-name"
                                                                  class="form-control"
                                                                  formControlName="surname"
                                                                  id="surname"
                                                                  placeholder=""
                                                                  type="text"/>
            @if (displayError(f.surname)) {
                <div class="form-input-error">
                    @if (f.surname.errors.required) {
                        <div>Surname is required</div>
                    }
                </div>
            }
        </div>
    </div>

    <div class="row">
        <div class="form-group col-md-6">
            <label for="email"><h3>Email:</h3></label> <input [ngClass]="{ 'is-invalid': displayError(f.email) }"
                                                              autocomplete="email"
                                                              class="form-control"
                                                              formControlName="email"
                                                              id="email"
                                                              placeholder=""
                                                              type="text"/>
            @if (displayError(f.email)) {
                <div class="form-input-error">
                    @if (f.email.errors.required) {
                        <div>Email is required</div>
                    }
                    @if (f.email.errors.email) {
                        <div>Invalid email</div>
                    }
                    @if (f.email.errors.duplicateEmail) {
                        <div>A user with this email address already exists</div>
                    }
                </div>
            }
        </div>

        <div class="form-group col-md-6">
            <label for="email-confirm"><h3>Confirm Email:</h3></label> <input (paste)="$event.preventDefault()"
                                                                              [ngClass]="{ 'is-invalid': displayError(f.confirmEmail) }"
                                                                              autocomplete="email"
                                                                              class="form-control"
                                                                              formControlName="confirmEmail"
                                                                              id="email-confirm"
                                                                              placeholder=""
                                                                              type="text"/>
            @if (displayError(f.confirmEmail)) {
                <div class="form-input-error">
                    @if (f.confirmEmail.errors.required) {
                        <div>Please confirm your Email</div>
                    }
                    @if (f.confirmEmail.errors.emailMismatch) {
                        <div>Email does not match</div>
                    }
                </div>
            }
        </div>
    </div>

    @if (isMerchantSelfServiceEnabled) {
        <div class="row">
            <div class="form-group col-md-6">
                <label for="password"><h3>Password:</h3></label>
                <input [ngClass]="{ 'is-invalid': displayError(f.password) }"
                       autocomplete="new-password"
                       class="form-control"
                       formControlName="password"
                       id="password"
                       placeholder=""
                       type="password"/>
                @if (displayError(f.password)) {
                    <div class="form-input-error">
                        @if (f.password.errors.required) {
                            <div>Password is required</div>
                        }
                        @if (f.password.errors.invalidPassword) {
                            <div>{{ f.password.errors.invalidPassword }}</div>
                        }
                    </div>
                }
            </div>

            <div class="form-group col-md-6">
                <label for="password-confirm"><h3>Confirm Password:</h3></label>
                <input (paste)="$event.preventDefault()"
                       [ngClass]="{ 'is-invalid': displayError(f.confirmPassword)}"
                       autocomplete="new-password"
                       class="form-control"
                       formControlName="confirmPassword"
                       id="password-confirm"
                       placeholder=""
                       type="password"/>
                @if (displayError(f.confirmPassword)) {
                    <div class="form-input-error">
                        @if (f.confirmPassword.errors.required) {
                            <div>Please confirm your password</div>
                        }
                        @if (f.confirmPassword.errors.passwordMismatch) {
                            <div>Password does not match</div>
                        }
                    </div>
                }
            </div>
        </div>
    }

    <div class="row">
        <div class="form-group col-12">
            <label for="nature-of-business"><h3>Nature of Business:</h3></label>
            <p-select [options]="natureOfBusinessList"
                      class="form-control"
                      formControlName="natureOfBusiness"
                      id="nature-of-business"
                      optionLabel="name"
                      optionValue="name"
                      placeholder="-- Please Select --"
                      styleClass="w-100"/>
            @if (displayError(f.natureOfBusiness)) {
                <div class="form-input-error">
                    @if (f.natureOfBusiness.errors.required) {
                        <div>Nature of business is required.</div>
                    }
                </div>
            }
        </div>
    </div>

    <div class="row margin-top-bottom-10">
        <div class="row col-12 text-center">
            <p style="width:100%">
                <span id="termsAcceptedLabel">
                    I have read and agree to accept the
                    <a [href]="privacyNoticeLink" class="terms-links" target="_blank">{{ privacyNoticeLabel }}</a>
                    and the
                    <a [href]="serviceTermsLink" class="terms-links" target="_blank">{{ serviceTermsLabel }}</a>
                </span>&nbsp;
                <p-checkbox [formControl]="$any(f['termsAccepted'])"
                            ariaLabelledBy="termsAcceptedLabel"
                            binary="true"
                            inputId="termsAccepted"></p-checkbox>
                <br> <br> @if (isMerchantSelfServiceEnabled) {
                By signing up, do you consent to receive additional marketing communication from us?&nbsp;
                <p-checkbox Consent
                            Marketing
                            [formControl]="$any(f['marketingConsent'])"
                            binary="true"
                            id="marketingConsent"></p-checkbox>
            }
            </p>

        </div>
    </div>

    <div class="row action-button-group">
        <div class="form-group col-md-6 login-button">
            <a [routerLink]="routes.PUBLIC.LOGIN.path" class="login-link mt-1"><h2>Return to Login</h2></a>
        </div>
        <div class="form-group col-md-6 float-left">
            <button (click)="onSubmit()" [disabled]="!termsAccepted" class="navy-btn" type="submit">
                Sign Up<i class="fa fa-chevron-right fas"></i>
            </button>
        </div>
    </div>

</form>
<pre [hidden]="!isDeveloperMode()"><code>{{ getAllErrors(form) | json }}</code></pre>
